import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  padding: 0 0 40px;
  overflow-x: hidden;

  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
  }

  .post-intro {
    h1 {
      margin: 20px 0 15px;
      font: ${font('default', 'medium', '18px/1.2')};
      color: ${props => props.theme.palette.primary.alphaDark};
    }

    .image {
      width: 100%;
      border-radius: 5px;
      overflow: hidden;

      img {
        display: block;
        width: 100%;
      }
    }

    .tags {
      list-style: none;
      padding: 0;
      display: flex;

      li {
        a {
          font: ${font('default', 'medium', '14px/19px')};
          padding: 2px 5px;
          background: ${props => props.theme.palette.general.greyLight};
          border: 1px solid ${props => props.theme.palette.general.grey};
          color: ${props => props.theme.palette.primary.alphaDark};
          text-transform: uppercase;
          text-decoration: none;
          border-radius: 2px;
          margin-right: 5px;
        }
      }
    }
  }

  .post-content {
    font: ${font('default', 'medium', '14px/1.6')};

    h2 {
      font: ${font('default', 'normal', '28px/1.6')};
      color: ${props => props.theme.palette.general.strong};
      margin: 40px 0 10px;
      ${bp('sm')`
        font-size: 22px;
      `}
    }

    a {
      color: ${props => props.theme.palette.primary.alpha};
    }

    p {
      margin: 0 0 25px;
    }

    img,
    iframe {
      & + .caption {
        font-size: 11px;
        color: ${props => props.theme.palette.general.dark};
      }
    }

    img {
      object-fit: cover;

      &.full-w {
        width: 100%;
      }
    }

    .columns {
      display: flex;
      margin: 20px auto;
      ${bp('sm')`
        flex-wrap: wrap;
      `}

      &--2 {
        > div {
          width: 100%;
          ${bp('sm')`
            margin-bottom: 20px;
          `}

          &:first-child {
            margin-right: 2%;
            ${bp('sm')`
              margin-right: 0;
            `}
          }
        }
      }
    }

    .full-video {
      position: relative;
      display: block;
      width: 100%;
      padding: 0;
      overflow: hidden;
      margin: 25px 0;

      &::before {
        content: '';
        display: block;
        padding-top: 56.25%;
      }

      iframe {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
      }
    }

    cite,
    blockquote {
      display: block;
      margin: 40px 0;

      p {
        color: ${props => props.theme.palette.primary.alpha};
        font: ${font('default', 'light', '32px/1.6')};
        font-style: italic;
        margin: 10px 0;
        ${bp('sm')`
          font-size: 20px;
        `}

        small {
          color: ${props => props.theme.palette.general.greyDark};
          font: ${font('default', 'normal', '14px/1.6')};
        }
      }
    }
  }

  .image-wrapper {
    ${bp('sm')`
        width: 90%!important;
        margin: auto;
    `}
  }

  .post-extra {
    padding: 20px 0;
    font: ${font('default', 'medium', '14px/1')};
    color: ${props => props.theme.palette.general.greyDark};
  }
`
